export default __webpack_public_path__ + "6ab513c7372b4f0047e5146f7acf8223.png";